// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1dUmg","rootCenter":"LoadMoreObserver_rootCenter__PxeNR","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1zDNg"};